import { useQuery } from '@tanstack/react-query';
import {
  getPlatformOrganisationFeatures,
  GetPlatformOrganisationFeaturesResponse,
} from '../api/platformApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { platformKeys } from './usePlatformOrganisations';

export function usePlatformOrganisationFeatures(orgId: string) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: [
      ...platformKeys.all,
      'organisations',
      orgId,
      'features',
    ] as const,
    queryFn:
      async (): Promise<GetPlatformOrganisationFeaturesResponse | null> => {
        return await getPlatformOrganisationFeatures(orgId);
      },
    enabled: isAuthenticated && !!orgId,
  });
}
